module.exports = __webpack_public_path__ + "img/taxi.81ccaa5e.svg";